import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import { ThemeContext } from './ThemeContext';

interface ThemeContextProviderProps {
    children?: any;
}

const ThemeContextProvider: React.FunctionComponent<ThemeContextProviderProps> = ({ children }: ThemeContextProviderProps) => {

    const [darkMode, setDarkMode] = React.useState(false)

    const onChangeTheme = () => {
        setDarkMode(!darkMode);
    }

    return (
        <ThemeContext.Provider value={{ darkMode, changeTheme: onChangeTheme }}>
            <ThemeProvider theme={createTheme({
                palette: {
                    mode: darkMode ? 'dark' : 'light',
                    primary: {
                        main: darkMode ? '#FFFFFF' : '#6D712E',
                    },
                    secondary: {
                        main: darkMode ? '#FFFFFF' : '#6D712E',
                    },
                },
            })}>
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
}

export default ThemeContextProvider;